import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';

import { NavMenuComponent } from "./nav-menu/nav-menu.component";
import { ToastNotificationComponent } from '../../utilities/components/toast-notification/toast-notification.component';

@Component({
  selector: 'main',
  imports: [RouterOutlet, NavMenuComponent, ToastNotificationComponent],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
  providers: [NgbModalConfig, NgbModal]
})
export class MainComponent {
  constructor(config: NgbModalConfig) {
		config.backdrop = 'static';
	}
}
